<template>
    <AccountLayout :loading="0" :isError=true>
        <div>
            <v-container id="login">
                <v-row id="login-box" class="d-flex justify-center">
                    <v-col
                        class="pl-0 pr-0"
                        cols="12"
                        sm="auto"
                        md="auto"
                        style="display:flex; z-index: 1; justify-center"
                    >
                        <div id="half-border">
                            <v-img
                                :src="require('../../assets/Group 92913.svg')"
                                contain
                                width="365"
                                height="325"
                                style="
                                    position: absolute;
                                    z-index: 1;
                                    margin-top: 3rem;
                                    margin-left: -8rem;
                                "
                            />
                        </div>
                        <v-card
                            width="540"
                            height="544px"
                            style="border-radius: 0px 30px 30px 0px"
                            elevation="0"
                        >
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <v-row class="mx-6">
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="text-center"
                                        >
                                            <div
                                                class="mt-7 prompt-title-500"
                                                style="
                                                    color: #255d98;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "message.loginPage.forgetPassword"
                                                    )
                                                }}
                                            </div>
                                        </v-col>
                                        <v-col
                                            sm="12"
                                            md="12"
                                            class="form-subtitle-400"
                                        >
                                            <p class="mx-md-16">
                                                {{
                                                    $t(
                                                        "message.loginPage.forgetMessage"
                                                    )
                                                }}
                                            </p>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                            <div class="pa-1 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.email"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field
                                                dense
                                                outlined
                                                hide-details="auto"
                                                v-bind:placeholder="
                                                    $t(
                                                        'message.loginPage.fillEmail'
                                                    )
                                                "
                                                v-model="email"
                                                :rules="emailRules"
                                                type="email"
                                                required
                                            >
                                                <template
                                                    #message="{ message }"
                                                >
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center"
                                        >
                                            <v-btn
                                                class="prompt-24"
                                                :disabled="!valid"
                                                :color="
                                                    checkFill
                                                        ? '#FF9800'
                                                        : '#AFADB1'
                                                "
                                                @click="validate"
                                                rounded
                                                height="40"
                                                width="300"
                                                style="
                                                    font-weight: 400;
                                                    font-size: 18px;
                                                    line-height: 24px;
                                                    letter-spacing: 0.05rem;
                                                    color: #ffffff;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "message.loginPage.confirm"
                                                    )
                                                }}
                                            </v-btn>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center mb-9"
                                        >
                                            <a
                                                class="
                                                    prompt-underline
                                                    text-decoration-underline
                                                "
                                                href="/login"
                                                style="color: #ff9800"
                                                >{{
                                                    $t("message.loginPage.back")
                                                }}</a
                                            >
                                        </v-col>
                                        <v-col v-if="isSubmit">
                                            
                                            <div v-if="foundEmail"
                                                class="d-flex align-start ml-3">
                                                <v-icon size="15" color="#00C487" class="mr-2 pt-1">mdi-check-circle</v-icon>
                                                <label class="prompt-chip">{{$t("message.loginPage.successfullSend")}}</label>
                                            </div>
                                            <div v-else
                                                class="d-flex align-start ml-3">
                                                <v-icon size="15" color="#FF544A" class="mr-2 pt-1">mdi-close-circle</v-icon>
                                                <label class="prompt-chip">{{$t("message.loginPage.failedSend")}}</label>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div id="orange-tab"></div>
        </div>
    </AccountLayout>
</template>

<script>
import AccountLayout from "../common/AccountLayout.vue";

export default {
    name: "ForgetPasswordComp",
    components: { AccountLayout },
    data: () => ({
        valid: true,
        email: "",
        foundEmail: true,
        isSubmit: false,
        path: "",
        emailRules: [
            (v) => !!v || "message.loginPage.fillEmail",
            (v) => /.+@.+\..+/.test(v) || "message.loginPage.incorrectEmail",
        ],
        link: "",
        isError:true
    }),
    computed: {
        checkFill() {
            const validate = this.$refs.form;
            const checkNull = this.email != "";
            return validate?.value && checkNull;
        },
        checkSubmit(){
            return this.isSubmit && this.foundEmail;
        }
    },
    methods: {
        async validate() {
            const valid = this.$refs.form.validate();
            if (valid) {
                this.isSubmit = true;
                try {
                    const {
                        data: { data },
                    } = await services.getChangePasswordLink({
                        email: this.email,
                        path: this.path,
                        register_link: localStorage.getItem("registerLink")
                    });

                    this.link = data.token;

                    if (
                        this.link != "" &&
                        this.link != null &&
                        this.link !== undefined
                    ) {
                        this.foundEmail = true;
                    } else {
                        this.foundEmail = false;
                    }
                } catch (err) {
                    console.log(err);
                    this.foundEmail = false;
                }
            }
        }
    },
    updated() {
        this.checkFill;
    },
    mounted() {
        this.path = window.location.origin;
        if (this.path == "localhost") {
            this.path = `${window.location.origin}`;
        }
        this.path = this.path + "/account/forget-password/";
    },
};

import * as services from "../../services";
</script>
